import { createFileRoute } from "@tanstack/react-router";

import { Navigate } from "@/lib/router-compat";
export const Route = createFileRoute("/billing")({
  component: () => <Navigate to="/settings?tab=billing" replace />,
});
